import React from 'react';
import { Info } from '@phosphor-icons/react';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';

type Props = {
	message: string;
	beforeIcon?: React.ReactNode;
	sx?: string;
	size?: number;
};

const HeruTooltip: React.FC<
	Props & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ message, size = 18 }) => {
	return (
		<TooltipProvider delayDuration={0}>
			<Tooltip>
				<TooltipTrigger asChild>
					<span className='inline-flex'>
						<Info size={size} />
					</span>
				</TooltipTrigger>
				<TooltipContent>
					<p>{message}</p>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
};

export default React.memo(HeruTooltip);
